import React from 'react';
import Chart from 'react-apexcharts';


class LineBarCharDataExposure extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        options: {
          chart: {
            id: 'line-bar-chart'
          },
          xaxis: {
            categories: [
              'PII Information',
              'Leaked Source code',
              'Leaked Postman URL',
              'Leaked Session',
              'Stealer Credentials',
              'Pastebin Records',
              'Stolen Credentials',
              'Telegram Forum Records'
            ]
          },
          colors: ['#08283f', '#08283f'],
          yaxis: [{
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#08283f'
            },
            labels: {
              style: {
                colors: '#08283f',
              }
            },
            title: {
              // text: 'No. of Instance',
              style: {
                color: '#08283f',
              },
            },
            min: 0,  // Minimum value for the left side
            // max: 600, // Maximum value for the left side
          }, {
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#08283f'
            },
            labels: {
              style: {
                colors: '#08283f',
              }
            },
            title: {
              // text: 'No. of Companies',
              style: {
                color: '#08283f',
              },
            },
            min: 0,  // Minimum value for the right side
            // max: 60, // Maximum value for the right side
          }],          
        },
        series: [
          {
            name: 'No. of Instance',
            type: 'column',
            data: [
              props?.dataexposure?.totalInstancesOfBreachedPersonalInformation,
              props?.dataexposure?.totalInstancesOfLeakedCodes,
              props?.dataexposure?.totalInstancesOfLeakedPostmanWorkspaceUrls,
              props?.dataexposure?.totalInstancesOfLeakedSessions,
              props?.dataexposure?.totalInstancesOfMalwareInfectedMachines,
              props?.dataexposure?.totalinstancesOfPastebinRecords,
              props?.dataexposure?.totalInstancesOfStolenCredentials,
              props?.dataexposure?.totalInstancesOfTelegramForumRecords
            ]
          },
          {
          name: 'No. of Companies',
          type: 'line',
          data: [
             props?.dataexposure?.totalCompaniesWithBreachedPersonalInformation,
             props?.dataexposure?.totalCompaniesWithLeakedCodes,
             props?.dataexposure?.totalCompaniesWithLeakedPostmanWorkspaceUrls,
             props?.dataexposure?.totalCompaniesWithLeakedSessions,
             props?.dataexposure?.totalCompaniesWithMalwareInfectedMachines,
             props?.dataexposure?.totalCompaniesWithPastebinRecords,
             props?.dataexposure?.totalCompaniesWithStolenCredentials,
             props?.dataexposure?.totalCompaniesWithTelegramForumRecords
            ]
        }],
      };
    }
  
    render() {
      return (
        <div id="chart">
          <Chart options={this.state.options} series={this.state.series} type="line" className="chart-class" height={400} />
        </div>
      );
    }
  }
  
  export default LineBarCharDataExposure;
  